/* eslint-disable @typescript-eslint/no-unused-vars */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';

import { RootState } from '@store/create-store';
import { Subscription } from '@scenario/models/subscription.model';

export interface SubscriptionState {
  isSubscribing?: boolean;
  subscriptions: Subscription[];
  isFetching?: boolean;
  isUnsubscribed?: boolean;
  error?: string;
}

const initialState: SubscriptionState = {
  subscriptions: [],
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    subscribeToNotification: (
      state,
      _action: PayloadAction<{ sourceId: number; zoneId: number }>,
    ) => {
      state.isSubscribing = true;
    },
    subscribeToNotificationSuccess: (state, action: PayloadAction<Subscription>) => {
      state.isSubscribing = false;
      state.subscriptions = [...state.subscriptions, action.payload];
    },
    subscribeToNotificationFailure: (state, action: PayloadAction<string>) => {
      state.isSubscribing = false;
      state.error = action.payload;
    },
    unsubscribeToNotification: (state, _action: PayloadAction<number>) => {
      state.isUnsubscribed = true;
    },
    unsubscribeToNotificationSuccess: (state, action: PayloadAction<number>) => {
      state.isUnsubscribed = true;
      const index = state.subscriptions.findIndex(sub => sub.id === action.payload);
      state.subscriptions.splice(index, 1);
      state.subscriptions = [...state.subscriptions];
    },
    unsubscribeToNotificationFailure: (state, action: PayloadAction<string>) => {
      state.isUnsubscribed = false;
      state.error = action.payload;
    },
    retrieveSubscriptions:state => {
      state.isFetching = true;
    },
    retrieveSubscriptionsSuccess: (state, action:PayloadAction<Subscription[]>) => {
      state.subscriptions = action.payload;
      state.isFetching = false;
    },
    retrieveSubscriptionsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    }
  },
});

export type SubscriptionViewModel = {
  isSubscribing?: boolean;
  isUnsubscribed?: boolean;
  error?: string;
  subscriptions: Subscription[];
};

const selectIsSubscribing = (state: RootState) => state.subscription.isSubscribing;
const selectIsUnsubscribed = (state: RootState) => state.subscription.isUnsubscribed;
const selectSubscriptions = (state: RootState) => state.subscription.subscriptions;
const selectError = (state: RootState) => state.subscription.error;


export const selectSubscriptionViewModel = createSelector(
  [selectIsSubscribing, selectIsUnsubscribed, selectError, selectSubscriptions],
  (isSubscribing, isUnsubscribed, error, subscriptions): SubscriptionViewModel => ({
    isSubscribing,
    isUnsubscribed,
    error,
    subscriptions
  }),
);
export const {
  subscribeToNotification,
  subscribeToNotificationSuccess,
  subscribeToNotificationFailure,
  unsubscribeToNotification,
  unsubscribeToNotificationSuccess,
  unsubscribeToNotificationFailure,
  retrieveSubscriptions,
  retrieveSubscriptionsSuccess,
  retrieveSubscriptionsFailure,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
